import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import Contact from './Contact';
import About from './About';
import Daftar from './Daftar';
import ComingSoonDaftar from './ComingSoonDaftar';
import Kegiatan from './Kegiatan';
import Vote from './Vote';
import Admin from './Admin';
import Header from './Header';
import { Instagram } from 'lucide-react';
import { PeriodProvider, usePeriod } from './PeriodContext';

function AppContent() {
  const { organizationData } = usePeriod();
  const orgName = organizationData?.nama || 'FKPO DIY';

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans selection:bg-indigo-500 selection:text-white">
      <Header />
      
      {/* Konten Hdsadasdalaman */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/daftar" element={<Daftar />} />
        <Route path="/daftar2027" element={<ComingSoonDaftar />} />
        <Route path="/kegiatan" element={< Kegiatan />} />
        <Route path="/pemilihan-ketua" element={<Vote />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>

      {/* --- FOOTER --- */}
      <footer className="relative bg-slate-950 border-t border-slate-800/80 mt-auto overflow-hidden">
        {/* Glow decoration */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-indigo-500/50 to-transparent"></div>
        
        <div className="container mx-auto px-6 py-10 flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Copyright & Info */}
          <div className="text-center md:text-left space-y-1">
            <div className="flex items-center justify-center md:justify-start gap-2">
              <h3 className="text-white font-extrabold text-lg tracking-tight">{orgName}</h3>
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-indigo-500/10 border border-indigo-500/30 text-indigo-400 font-bold uppercase">
                Official
              </span>
            </div>
            <p className="text-slate-400 text-xs sm:text-sm">
              Wadah Kolaborasi, Aspirasi, dan Sinergi Pelajar se-Kabupaten Kulon Progo, D.I. Yogyakarta.
            </p>
            <p className="text-slate-500 text-xs">
              &copy; {new Date().getFullYear()} {orgName}. All rights reserved.
            </p>
          </div>

          {/* Social Links & Official tags */}
          <div className="flex items-center gap-4">
            <a 
              href="https://www.instagram.com/fkpo_kulonprogo/" 
              target="_blank" 
              rel="noreferrer" 
              aria-label="Instagram FKPO Kulon Progo"
              className="flex items-center gap-2 px-4 py-2 bg-slate-900 border border-slate-800 hover:border-pink-500/40 rounded-full text-slate-300 hover:text-white hover:bg-slate-800/80 transition-all group shadow-lg"
            >
              <div className="p-1 rounded-full bg-pink-500/10 text-pink-400 group-hover:bg-pink-500 group-hover:text-white transition-colors">
                <Instagram className="w-4 h-4" />
              </div>
              <span className="text-xs font-semibold">@fkpo_kulonprogo</span>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <PeriodProvider>
      <AppContent />
    </PeriodProvider>
  );
}

export default App;

